var escapeStringRegExp = require('./escape-string-regex')

/**
 * @func toRegExp
 * @memberOf matcher
 * @module to-regexp
 * @extends escapeStringRegExp
 *
 * @param {string} str string to escape
 * @return {string} escaped str
 *
 * @example
 *
 *    toRegExp('*')
 *    => '.*'
 *
 *    toRegExp('eh')
 *    => 'eh'
 *
 */
module.exports = function (str) { return escapeStringRegExp(str).replace(/\\\*/g, '.*'); }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG8tcmVnZXhwLmpzIiwic291cmNlcyI6WyJ0by1yZWdleHAuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgZXNjYXBlU3RyaW5nUmVnRXhwID0gcmVxdWlyZSgnLi9lc2NhcGUtc3RyaW5nLXJlZ2V4JylcblxuLyoqXG4gKiBAZnVuYyB0b1JlZ0V4cFxuICogQG1lbWJlck9mIG1hdGNoZXJcbiAqIEBtb2R1bGUgdG8tcmVnZXhwXG4gKiBAZXh0ZW5kcyBlc2NhcGVTdHJpbmdSZWdFeHBcbiAqXG4gKiBAcGFyYW0ge3N0cmluZ30gc3RyIHN0cmluZyB0byBlc2NhcGVcbiAqIEByZXR1cm4ge3N0cmluZ30gZXNjYXBlZCBzdHJcbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqICAgIHRvUmVnRXhwKCcqJylcbiAqICAgID0+ICcuKidcbiAqXG4gKiAgICB0b1JlZ0V4cCgnZWgnKVxuICogICAgPT4gJ2VoJ1xuICpcbiAqL1xubW9kdWxlLmV4cG9ydHMgPSBzdHIgPT4gZXNjYXBlU3RyaW5nUmVnRXhwKHN0cikucmVwbGFjZSgvXFxcXFxcKi9nLCAnLionKVxuIl0sIm5hbWVzIjpbImNvbnN0Il0sIm1hcHBpbmdzIjoiQUFBQUEsR0FBSyxDQUFDLGtCQUFrQixHQUFHLE9BQU8sQ0FBQyx1QkFBdUIsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFvQjNELE1BQU0sQ0FBQyxPQUFPLEdBQUcsVUFBQSxHQUFHLENBQUEsQ0FBQyxBQUFHLFNBQUEsa0JBQWtCLENBQUMsR0FBRyxDQUFDLENBQUMsT0FBTyxDQUFDLE9BQU8sRUFBRSxJQUFJLENBQUMsR0FBQTsifQ==